module.exports = __webpack_public_path__ + "img/top-bar.c014b87d.webp";